export const SUBJECT_EXTENSION_PROMPT_NAME = 'subjectExtensions';
